import React, { useState, useEffect, useRef } from "react";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";

const FieldHelpPopover = ({ content, fieldName }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="ml-1 text-lightblue hover:text-orange"
        title={`${fieldName} help`}
      >
        <QuestionMarkCircleIcon className="h-4 w-4 inline" />
      </button>
      {open && (
        <div
          role="tooltip"
          className="absolute z-10 mt-1 bg-deepblue border border-lightblue rounded-md p-3 text-sm text-lightgray w-64"
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default FieldHelpPopover;
